import { useState, useEffect } from "react"

const useIsMobile = (breakpoint = 739) => {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkIsMobile = () => {
      if (typeof window !== "undefined") {
        const width = window.innerWidth
        setIsMobile(width < breakpoint)
      }
    }

    // Check on mount
    checkIsMobile()

    // Add event listener for resize
    window.addEventListener("resize", checkIsMobile)

    // Cleanup event listener
    return () => {
      window.removeEventListener("resize", checkIsMobile)
    }
  }, [breakpoint])

  return isMobile
}

export default useIsMobile
